import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';
import { environment } from '../../../../environments/environment';
import { SignInPageService } from './sign-in-page.service';
import { UserService } from '../../../user.service';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-sign-in-page',
  templateUrl: './sign-in-page.component.html',
  styleUrls: ['./sign-in-page.component.scss']
})
export class SignInPageComponent implements OnInit {
  private API_URL = environment.API_URL;
  public data: any;
  
  logForm = this.formBuilder.group({
    identifier: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required]
  });

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private http: HttpClient,
    private notifier: NotifierService,
    private content: SignInPageService,
    private route: ActivatedRoute,
    private authService: UserService
  ) {
  }

  ngOnInit(): void {
    // Redirection si déjà connecté
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
      return;
    }

    // Gestion de la confirmation d'email - UNE SEULE FOIS
    this.route.queryParams.subscribe(params => {
      if (params['confirmed'] === 'true') {
        // Vérifier si la notification a déjà été affichée dans cette session
        const confirmationShown = sessionStorage.getItem('email_confirmation_shown');
        
        if (!confirmationShown) {
          this.notifier.notify(
            'success',
            '✅ Félicitations ! Votre compte a été validé avec succès. Vous pouvez maintenant vous connecter.'
          );
          
          // Marquer la notification comme affichée pour cette session
          sessionStorage.setItem('email_confirmation_shown', 'true');
        }
        
        // Nettoyer l'URL pour éviter les rafraîchissements avec le paramètre
        this.router.navigate(['/sign-in'], { replaceUrl: true });
      }
    });
  }

  onLogin(): void {
    if (this.logForm.invalid) {
      if (this.logForm.get('identifier')?.errors?.['email']) {
        this.notifier.notify('error', '❌ L\'adresse email n\'est pas valide.');
      } else {
        this.notifier.notify('error', '❌ Veuillez remplir tous les champs.');
      }
      return;
    }

    const { identifier, password } = this.logForm.value;
    const url = `${this.API_URL}/auth/local`;

    this.http.post<any>(url, { identifier, password }).subscribe({
      next: (response) => {
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('goca_users', JSON.stringify(response));
          this.authService.startInactivityTimer();
          
          // Nettoyer la marque de confirmation lors de la connexion réussie
          sessionStorage.removeItem('email_confirmation_shown');
          
          setTimeout(() => window.location.reload(), 500);
        }
        this.notifier.notify('success', '✅ Connexion réussie ! Bienvenue.');
      },
      error: (error) => {
        const message = error?.error?.error?.message || '';
        
        if (message.toLowerCase().includes('email is not confirmed')) {
          this.notifier.notify(
            'error',
            '⚠️ Votre adresse email n\'est pas encore confirmée. Veuillez vérifier votre boîte mail et cliquer sur le lien de confirmation.'
          );
        } else {
          this.notifier.notify('error', '❌ L\'email ou le mot de passe est incorrect.');
        }
      }
    });
  }
}